/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
export * from "./Constants";
export * from "./Exception";
export * from "./FormatSpecHandle";
export * from "./Interfaces";
export * from "./Parser";
export * from "./ParserSpec";
export * from "./Quantity";
export * from "./UnitConversions";
export * from "./Unit";
export * from "./Formatter/Format";
export * from "./Formatter/FormatterSpec";
export * from "./Formatter/FormatEnums";
export * from "./Formatter/Formatter";
export * from "./Formatter/FormattingReadyCollector";
export * from "./Formatter/Interfaces";
export * from "./QuantityLoggerCategory";

export * from "./UnitConversion/UnitConversion";
export * from "./UnitConversion/UnitDefinitionResolver";
export * from "./SerializedUnitSchema";
export { BasicUnitsProvider } from "./BasicUnitsProvider";
export * from "./CompositeUnitsProvider";
export * from "./generated/Units.generated";
export * from "./internal/cross-package";

/** @docs-package-description
 * The core-quantity package contains classes, interfaces, and definitions for formatting and parsing quantity values.
 */

/**
 * @docs-group-description Quantity
 * Classes, Interfaces, and definitions used to format and parse quantity values.
 */
/**
 * @docs-group-description BasicUnitsProvider
 * A UnitsProvider backed by the bundled BIS Units schema JSON asset.
 */
/**
 * @docs-group-description CompositeUnitsProvider
 * Factory and composition utilities for layering multiple UnitsProviders.
 */
/**
 * @docs-group-description Units.generated
 * Generated built-in canonical unit, phenomenon, and unit-system identifiers.
 */
/**
 * @docs-group-description Logging
 * Logger categories used by this package.
 */
